import React from "react";
import { PageHero } from "../components/PageHero";
import { Mail } from "lucide-react";

const HERO_ABOUT = "https://static.prod-images.emergentagent.com/jobs/a6c16944-cdbb-43fa-8ac4-8a5b05ddef75/images/a78c61bc5fcba90fb869a6aea00c8ee7d2bd188a04c951099439b17290ba9af6.png";

const WaIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="#22c55e">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.978-1.413A9.953 9.953 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.95 7.95 0 0 1-4.076-1.12l-.292-.173-3.032.861.872-3.018-.19-.31A7.96 7.96 0 0 1 4 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z" />
  </svg>
);

const handleEmailClick = () => {
  window.open(
    "https://mail.google.com/mail/?view=cm&to=springKids.edu@gmail.com&su=Enquiry from Spring Kids Website",
    "_blank"
  );
};

export default function Enquiry() {
  return (
    <div data-testid="page-enquiry">
      <PageHero title="Get in Touch" breadcrumb="Enquiry" illustration={HERO_ABOUT} illustrationAlt="Parent with child" />

      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <span className="section-label">We'd Love to Hear from You</span>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-kid-navy">Reach Out to Us</h2>
            <p className="mt-4 text-kid-navy/70 max-w-xl mx-auto text-lg">
              Interested in joining Spring Kids? Contact us directly via WhatsApp or email and we'll get back to you promptly.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-10 items-stretch">
            {/* WhatsApp */}
            <a
              href="https://wa.me/919845025709?text=Hi%2C%20I%20would%20like%20to%20know%20more%20about%20Spring%20Kids%20Preschool"
              target="_blank"
              rel="noopener noreferrer"
              className="kid-card flex flex-col items-center text-center gap-5 hover:shadow-md transition-shadow no-underline"
              data-testid="enquiry-whatsapp-btn"
            >
              <div className="w-20 h-20 rounded-full bg-[#E6F8E4] flex items-center justify-center">
                <WaIcon />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-kid-navy">Chat on WhatsApp</h3>
                <p className="text-kid-navy/60 mt-2 leading-relaxed">
                  The fastest way to reach us. Send a message and we'll respond within minutes during school hours.
                </p>
              </div>
              <span className="btn-amber w-full text-center">Open WhatsApp →</span>
              <p className="text-kid-navy/40 text-sm -mt-2">Mon – Sat, 9 am – 6 pm</p>
            </a>

            {/* Email */}
            <div
              className="kid-card flex flex-col items-center text-center gap-5 cursor-pointer hover:shadow-md transition-shadow"
              onClick={handleEmailClick}
              data-testid="enquiry-email-btn"
            >
              <div className="w-20 h-20 rounded-full bg-kid-lilac flex items-center justify-center text-white">
                <Mail size={36} />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-kid-navy">Send an Email</h3>
                <p className="text-kid-navy/60 mt-2 leading-relaxed">
                  Prefer email? Write to us with your questions and we'll reply within one working day.
                </p>
              </div>
              <button className="btn-lilac w-full flex items-center justify-center gap-2">
                <Mail size={18} /> Send Email
              </button>
              <p className="text-kid-navy/40 text-sm -mt-2">Opens Gmail in a new tab</p>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}
